import { render, staticRenderFns } from "./transfer-record.vue?vue&type=template&id=610d3720&scoped=true&"
import script from "./transfer-record.vue?vue&type=script&lang=js&"
export * from "./transfer-record.vue?vue&type=script&lang=js&"
import style0 from "./transfer-record.vue?vue&type=style&index=0&id=610d3720&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d3720",
  null
  
)

export default component.exports